export const AssignTypeTranslation: { [key: number]: string } = {
  1: $localize`Unassigned`,
  2: $localize`Patient`,
  3: $localize`Staff`,
  4: $localize`Asset`,
};
